import { CheckableInput_default } from "./chunk-W4WFEW7W.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Radio/Radio.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var RADIO_CLASSNAME_MAP = {};
var Radio = forwardRef((_a, ref) => {
  var _b = _a,
    {
      className
    } = _b,
    rest = __objRest(_b, ["className"]);
  return /* @__PURE__ */jsx(CheckableInput_default, __spreadValues({
    ref,
    type: "radio",
    className: clsx("pd:radio", className)
  }, rest));
});
var Radio_default = Radio;
export { RADIO_CLASSNAME_MAP, Radio_default };